import { translate } from '@repo/phrase';
import type { AssetType } from '@repo/types/asset';
import { Heading, Paragraph } from '@repo/ui/typography';

import styles from './styles.module.scss';

interface Props {
    assetType: AssetType;
    orderType?: string | undefined;
    assetId: string;
    creationDate: string;
}

interface HeaderItem {
    name: string;
    value: string;
}

const HeaderTableRow = ({ name, value }: HeaderItem) => {
    return (
        <div className={styles.asset_summary_header_row}>
            <Heading headingSize="s">{name}</Heading>
            <Paragraph>{value}</Paragraph>
        </div>
    );
};

export const AssetSummaryHeader = ({ assetId, creationDate, assetType, orderType }: Props) => {
    return (
        <div className={styles.asset_summary_header_table}>
            <HeaderTableRow
                name={translate(`asset_summary_modal_details_id_${orderType ?? assetType}`)}
                value={assetId}
            />
            <HeaderTableRow name={translate('asset_summary_modal_details_creation_date')} value={creationDate} />
        </div>
    );
};
